import clsx from 'clsx';
import { ReactNode } from 'react';

export default function KPICard({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return (
    <div
      className={clsx(
        'w-full p-[12px] 4xl:p-[20px] 5xl:p-[24px] min-h-[126px] 4xl:min-h-[148px] bg-white shadow-card rounded-[12px] border border-primary-100',
        className
      )}
    >
      {children}
    </div>
  );
}
